import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section className="max-w-xl mx-auto text-center space-y-4 py-12">
      <h2 className="text-4xl font-bold">404</h2>
      <p className="text-muted-foreground">{t("notFound.message")}</p>
      <Link className="text-primary underline" to="/">
        {t("notFound.backHome")}
      </Link>
    </section>
  );
}
